import { render, staticRenderFns } from "./ResubmitRemittance.vue?vue&type=template&id=15084186"
import script from "./ResubmitRemittance.vue?vue&type=script&lang=js"
export * from "./ResubmitRemittance.vue?vue&type=script&lang=js"
import style0 from "./ResubmitRemittance.vue?vue&type=style&index=0&id=15084186&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports